import { render, staticRenderFns } from "./demandList.vue?vue&type=template&id=4199aa33&scoped=true&"
import script from "./demandList.vue?vue&type=script&lang=js&"
export * from "./demandList.vue?vue&type=script&lang=js&"
import style0 from "./demandList.vue?vue&type=style&index=0&id=4199aa33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4199aa33",
  null
  
)

export default component.exports